import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../data/DataOperation.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelElementsContratReservation : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    operation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheElementsContratReservation extends Component {
    _creationContent() {
        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Projet de construction-vente"
                            maxLength={MaxLengths.operation.texteContratProjetConstruction}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "texteContratProjetConstruction", newValue)}
                            rows={6}
                            value={this.state.operation.texteContratProjetConstruction}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Dispositions diverses"
                            maxLength={MaxLengths.operation.texteContratDispositionsDiverses}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "texteContratDispositionsDiverses", newValue)}
                            rows={6}
                            value={this.state.operation.texteContratDispositionsDiverses}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Liste des annexes"
                            maxLength={MaxLengths.operation.texteContratListesAnnexes}
                            multiline
                            onChange={(event, newValue) => this._onMiseAJourChamp("operation", "texteContratListesAnnexes", newValue)}
                            rows={6}
                            value={this.state.operation.texteContratListesAnnexes}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        if (this.state.operation.idOperation === undefined) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des éléments du contrat de réservation de l\'opération'
            });

            var chargementFicheIdentification = DataOperation._chargementFicheIdentification();

            chargementFicheIdentification.then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let retourData = responseFetch.reponseAPIobjet;
                    let operation = retourData[0];

                    let stateTemp = {};
                    stateTemp.operation = operation;
                    stateTemp.titrePanel = 'Modifier l\'opération';
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
        }
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            //estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateOperation);
        }
        else {
            estValide = false;
        }

        return estValide;
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement des éléments du contrat de réservation en cours'
        });

        var enregistrementElementsContratReservation = DataOperation._onEnregistrementElementsContratReservation(this.state.operation);

        enregistrementElementsContratReservation.then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                this.props.onEnregistrementFiche();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onRenderFooterContent = () => {
        let boutonActif = this._validationFormulaire(this.state.operation);

        return (<div>
            <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
        </div>);
    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur);
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if (!this.state.enCoursDeTraitement && this.props.onPeutChargerLeComposant) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        let content = this._creationContent();

        return (
            <Panel
                isOpen={this.props.onAffichePanelElementsContratReservation}
                headerText="Eléments du contrat de réservation"
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {content}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }
}